import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, TextField, Button, Box, Card, CardContent, Typography, Avatar } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import ShieldIcon from '@mui/icons-material/Security';
import theme from '../theme';
import { GoogleLogin } from '@react-oauth/google';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('/papi2/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password, database: 'AP' }),
            });

            if (response.ok) {
                const data = await response.json();
                localStorage.setItem('token', data.token);
                localStorage.setItem('nome', data.nome);
                localStorage.setItem('cognome', data.cognome);
                localStorage.setItem('livello', data.livello);
                navigate('/dashboard');
            } else {
                alert('Login failed. Please check your credentials.');
            }
        } catch (err) {
            console.error(err);
            alert('Service unreachable.');
        }
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            const response = await fetch('/papi2/auth/google-login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token: credentialResponse.credential, database: 'AP' }),
            });

            if (response.ok) {
                const data = await response.json();
                localStorage.setItem('token', data.token);
                localStorage.setItem('nome', data.nome);
                localStorage.setItem('cognome', data.cognome);
                localStorage.setItem('livello', data.livello);
                navigate('/dashboard');
            } else {
                console.error('Google Login failed with status:', response.status);
                alert('Google Login failed. Please try again.');
            }
        } catch (error) {
            console.error('Frontend Google Login Error:', error);
            alert('An error occurred during login.');
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    background: 'linear-gradient(135deg, #1b5e20 0%, #357a38 50%, #66bb6a 100%)', // Premium Green Gradient
                    backgroundSize: '400% 400%',
                    animation: 'gradientAnimation 15s ease infinite',
                    '@keyframes gradientAnimation': {
                        '0%': { backgroundPosition: '0% 50%' },
                        '50%': { backgroundPosition: '100% 50%' },
                        '100%': { backgroundPosition: '0% 50%' },
                    },
                }}
            >
                <Card
                    elevation={0}
                    sx={{
                        width: 380,
                        padding: 4,
                        background: 'rgba(255, 255, 255, 0.9)', // Glass-like opacity
                        backdropFilter: 'blur(20px)',
                        borderRadius: 4,
                        boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.2)',
                        border: '1px solid rgba(255, 255, 255, 0.18)'
                    }}
                >
                    <CardContent>
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Avatar sx={{
                                bgcolor: 'secondary.main',
                                mb: 2,
                                width: 56,
                                height: 56,
                                boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
                            }}>
                                <ShieldIcon fontSize="large" sx={{ color: '#fff' }} />
                            </Avatar>

                            <Typography variant="h4" sx={{ fontWeight: 700, color: 'primary.dark', mb: 1 }}>
                                Paladino
                            </Typography>
                            <Typography variant="body2" color="text.secondary" gutterBottom sx={{ mb: 3 }}>
                                Secure Access Portal
                            </Typography>

                            <form onSubmit={handleLogin} style={{ width: '100%' }}>
                                <TextField
                                    label="Username"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    sx={{ mb: 2 }}
                                />
                                <TextField
                                    label="Password"
                                    type="password"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    sx={{ mb: 3 }}
                                />
                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    size="large"
                                    sx={{
                                        py: 1.5,
                                        fontSize: '1rem',
                                        background: 'linear-gradient(45deg, #357a38 30%, #66bb6a 90%)',
                                        boxShadow: '0 3px 5px 2px rgba(53, 122, 56, .3)',
                                        '&:hover': {
                                            background: 'linear-gradient(45deg, #2e5c31 30%, #357a38 90%)',
                                        },
                                        mb: 3
                                    }}
                                >
                                    Login
                                </Button>
                            </form>

                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                <GoogleLogin
                                    theme="filled_blue"
                                    shape="circle"
                                    width="100%"
                                    onSuccess={handleGoogleSuccess}
                                    onError={() => {
                                        console.log('Google Login Failed');
                                        alert('Google Login Failed');
                                    }}
                                />
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </ThemeProvider>
    );
};

export default Login;
